import React, { useEffect, useState } from "react";
import { Portal } from "./Portal";
import { useModal } from "./ModalContext";
import { useTranslation } from "../../hooks/useTranslation";
import "./SourceInfoModal.scss";
import { DATA_SOURCE } from "@/types/enum.ts";

export const SourceInfoModal = () => {
  const { isSourceInfoModalOpen, sourceInfoModalData, closeSourceInfoModal } =
    useModal();
  const { t } = useTranslation();
  const [viewportHeight, setViewportHeight] = useState("100vh");

  useEffect(() => {
    const updateViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      setViewportHeight(`${window.innerHeight}px`);
    };

    updateViewportHeight();
    window.addEventListener("resize", updateViewportHeight);
    window.addEventListener("orientationchange", updateViewportHeight);

    return () => {
      window.removeEventListener("resize", updateViewportHeight);
      window.removeEventListener("orientationchange", updateViewportHeight);
    };
  }, []);

  if (!isSourceInfoModalOpen) return null;

  return (
    <Portal containerId="source-info-modal-portal">
      <div
        className="source-info-modal-overlay"
        onClick={closeSourceInfoModal}
        style={{ height: viewportHeight }}
      >
        <div className="source-info-modal" onClick={(e) => e.stopPropagation()}>
          <div className="source-info-modal-header">
            <h3 className="source-info-modal-title">
              {t("contact.sourceInfo")}
            </h3>
            <button
              className="source-info-modal-close"
              onClick={closeSourceInfoModal}
            >
              <img src="/assets/icons/Xbutton.svg" alt="close" />
            </button>
          </div>
          <div className="source-info-modal-content">
            <div className="source-info-item">
              <div className="source-info-label">{t("contact.uiOriginal")}</div>
              <div className="source-info-data">
                {sourceInfoModalData.productName || "프로덕트"}
              </div>
            </div>
            <div className="source-info-item">
              <div className="source-info-label">{t("contact.source")}</div>
              <div className="source-info-data">
                {sourceInfoModalData.dataSource === DATA_SOURCE.MOBBIN
                  ? "Mobbin"
                  : t("contact.screenshot")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};
